import { NgModule } from "@angular/core";
import { SharedModule } from "src/app/shared/shared.module";
import { AbaAmortizacoesComponent } from "./aba-amortizacoes.component";

@NgModule({
    declarations: [AbaAmortizacoesComponent],
    imports:[SharedModule],
    exports:[AbaAmortizacoesComponent]
})
export class AbaAmortizacoesModule {}